<!-- ═══════════════════════════════════════════════════════════════════════
     HERO VISUAL — Carte « Dernières actualités »
     ═══════════════════════════════════════════════════════════════════════ -->
<div class="arp-news-card" *ngIf="postsData?.length; else emptyState">

  <!-- Header avec badge LIVE -->
  <div class="arp-news-card__head">
    <div class="arp-news-card__head-left">
      <span class="arp-news-card__pulse">
        <span class="arp-news-card__pulse-core"></span>
      </span>
      <h3 class="arp-news-card__title">{{ 'actualites' | translate }}</h3>
    </div>
    <a [routerLink]="['/articles']" class="arp-news-card__see-all">
      {{ 'Voir tout' | translate }}
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M5 12h14M13 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
  </div>

  <!-- Liste des articles -->
  <ul class="arp-news-list">
    <li *ngFor="let p of postsData; trackBy: trackById" class="arp-news-item">
      <a [routerLink]="postLink(p)" class="arp-news-link">

        <div class="arp-news-thumb">
          <img [src]="loadImage(p.featured_image)"
               [alt]="translateField(p.title)"
               loading="lazy"
               (error)="$event.target.src='/assets/images/default_image.png'" />
        </div>

        <div class="arp-news-body">
          <div class="arp-news-meta">
            <span class="arp-news-tag" *ngIf="p.category?.name">
              {{ translateField(p.category!.name) }}
            </span>
            <span class="arp-news-time">
              <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5">
                <circle cx="8" cy="8" r="6.5"/>
                <path d="M8 4v4l2.5 1.5" stroke-linecap="round"/>
              </svg>
              {{ p.created_at | timeAgo:getLang() }}
            </span>
          </div>
          <p class="arp-news-headline">
            {{ truncate(translateField(p.title), 110) }}
          </p>
        </div>

        <div class="arp-news-arrow">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </a>
    </li>
  </ul>

</div>

<!-- État vide / chargement -->
<ng-template #emptyState>
  <div class="arp-news-card arp-news-card--skeleton">
    <div class="arp-news-card__head">
      <div class="arp-news-card__head-left">
        <span class="arp-news-card__pulse">
          <span class="arp-news-card__pulse-core"></span>
        </span>
        <h3 class="arp-news-card__title">{{ 'actualites' | translate }}</h3>
      </div>
    </div>
    <ul class="arp-news-list">
      <li class="arp-news-item arp-news-item--skel" *ngFor="let _ of [1,2,3]">
        <div class="arp-news-thumb arp-skel"></div>
        <div class="arp-news-body">
          <div class="arp-skel arp-skel--line" style="width: 40%"></div>
          <div class="arp-skel arp-skel--line" style="width: 85%; margin-top: 8px"></div>
          <div class="arp-skel arp-skel--line" style="width: 60%; margin-top: 6px"></div>
        </div>
      </li>
    </ul>
  </div>
</ng-template>
